export const getInsertionOrderSelectorStyle = () => ({
  MultipleInsertionOrderSelector: {
    padding: 10,
    width: 870,
    border: 0,
    borderRadius: 2,
    boxShadow: '0 3.2px 7.2px 0 rgba(0,0,0,.132), 0 0.6px 1.8px 0 rgba(0,0,0,.108)',
    backgroundColor: '#fff',
  },

  SelectorButton: {
    flex: '0 0 auto',
    border: 'none',
    height: 56,
    fontWeight: 'unset !important',
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 4,
  },
  ChevronDownIcon: {
    height: 20,
    fontSize: '12px !important',
    top: '1px !important',
  },
  ButtonDescription: {
    verticalAlign: 'text-bottom',
    marginRight: 4,
    maxWidth: 200,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: 'inline-block',
  },
});
